import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
	getReportingTypeList as getReportingTypeListApi,
	getReportingTypeListQuery as getReportingTypeListQueryApi,
	getReportingType as getReportingTypeApi,
	addNewReportingTypeApi,
	updateReportingTypeApi,
	deleteReportingTypeApi,
	checkReportingTypeExistsApi,
} from '../../helpers/reporting_type/api_helper';

export const getReportingTypeList = createAsyncThunk(
	'reportingType/getReportingTypeList',
	async () => {
		try {
			const response = await getReportingTypeListApi();
			return response.data || response;
		} catch (error) {
			toast.error('Error al obtener los tipos de reportabilidad.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const getReportingTypeListQuery = createAsyncThunk(
	'reportingType/getReportingTypeListQuery',
	async params => {
		try {
			const response = getReportingTypeListQueryApi(params);
			return response;
		} catch (error) {
			throw new Error(error);
		}
	}
);

export const getReportingType = createAsyncThunk(
	'reportingType/getReportingType',
	async reporting_type_id => {
		try {
			const response = await getReportingTypeApi(reporting_type_id);
			return response;
		} catch (error) {
			toast.error('Error al obtener el tipo de reportabilidad.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const addNewReportingType = createAsyncThunk(
	'reportingType/addNewReportingType',
	async reporting_type => {
		try {
			const response = await addNewReportingTypeApi(reporting_type);
			toast.success('Tipo de Reportabilidad agregado exitosamente.', {
				autoClose: 3000,
			});
			return response.data || response;
		} catch (error) {
			toast.error('Error al agregar el tipo de reportabilidad.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const updateReportingType = createAsyncThunk(
	'reportingType/updateReportingType',
	async reporting_type => {
		try {
			const response = await updateReportingTypeApi(reporting_type);
			toast.success('Tipo de Reportabilidad actualizado exitosamente.', {
				autoClose: 3000,
			});
			return response.data || response;
		} catch (error) {
			toast.error('Error al actualizar el tipo de reportabilidad.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const deleteReportingType = createAsyncThunk(
	'reportingType/deleteReportingType',
	async reporting_type => {
		try {
			await deleteReportingTypeApi(reporting_type._id);
			toast.success('Tipo de Reportabilidad eliminado exitosamente.', {
				autoClose: 3000,
			});
			return reporting_type;
		} catch (error) {
			toast.error('Error al eliminar el tipo de reportabilidad.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const checkReportingTypeExists = createAsyncThunk(
	'reportingType/checkReportingTypeExists',
	async name => {
		try {
			const response = await checkReportingTypeExistsApi(name);
			return response;
		} catch (error) {
			return { exists: false };
		}
	}
);
